import React, { useContext } from 'react';
import { Context } from '../../../Context';
import {IProps, IState} from './types';
import * as S from './styles';
import { sameElementType } from '@utils/editor'
import BackgroundColorComandOption from './CommandsOptions/BackgroundColorCommandOption';
import BorderComandOption from './CommandsOptions/BorderCommandOption';

const ShapeCommandBar:React.FC<IProps> = (props) => {
  const context = useContext(Context);
  
  return (
    <S.Root>   
      <BackgroundColorComandOption/>      
      <S.Line/>
      <BorderComandOption/>
      {
        !sameElementType(context.editorStatus.selectedElementsId,"Shape",context.data) &&
        <S.Line/>
      }
    </S.Root>
  );
}

export default ShapeCommandBar;